import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/provider', [
    {
      path: '',
      name: 'provider',
      redirect: { name: 'provider-list' },
    },
    {
      path: '/list',
      name: 'provider-list',
      component: () => import('@/views/provider/ProviderInstanceList.vue'),
    },
    {
      path: '/create',
      name: 'provider-create',
      component: () => import('@/views/provider/ProviderInstanceCreate.vue'),
    },
    {
      path: '/:id(\\d+)',
      name: 'provider-edit',
      component: () => import('@/views/provider/ProviderInstanceEdit.vue'),
    },
    ...withPrefix('/type', [
      {
        path: '',
        name: 'provider-type',
        redirect: { name: 'provider-type-list' },
      },
      {
        path: '/list',
        name: 'provider-type-list',
        component: () => import('@/views/provider/ProviderTypeList.vue'),
      },
      {
        path: '/create',
        name: 'provider-type-create',
        component: () => import('@/views/provider/ProviderTypeCreate.vue'),
      },
      {
        path: '/:id(\\d+)',
        name: 'provider-type-edit',
        component: () => import('@/views/provider/ProviderTypeEdit.vue'),
      },
    ]),
  ]);
};
